export const GET_REBATESPENDDATA = 'GET_REBATESPENDDATA';
export const SET_REBATESPENDDATA = 'SET_REBATESPENDDATA';
export const GET_REBATESPENDBYID = 'GET_REBATESPENDBYID';
export const SET_REBATESPEND = 'SET_REBATESPEND';
export const GET_CREATEUPDATEREBATESPEND = 'GET_CREATEUPDATEREBATESPEND';
export const GET_SAVEDREBATESPENDFLAG = 'GET_SAVEDREBATESPENDFLAG';
export const SET_SAVEDREBATESPENDFLAG = 'SET_SAVEDREBATESPENDFLAG';